import React, { useState } from "react";
import { Avatar, Menu, MenuItem } from "@mui/material";
import { useDispatch } from "react-redux";
import { logOut } from "../../../redux/slice/authSlice";

const HeaderSection = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch();
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    // navigation("membership");
    setAnchorEl(null);
  };

  return (
    <div className="wrap-branding">
      <h4 className="text-white "> </h4>
      <div className="d-flex gap-4">
        <div>
          <Avatar
            id="basic-button"
            // src={urlImg !== "" ? urlImg : ""}
            aria-controls={open ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
          />

          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            {/* <MenuItem
              onClick={() => {
                handleClose();
                navigation("/dashboard/profile");
              }}
            >
              Perfil
            </MenuItem>
            <MenuItem
              onClick={() => {
                navigation("/dashboard/account");
                handleClose();
              }}
            >
              Mi cuenta
            </MenuItem> */}
            <MenuItem
              onClick={() => {
                handleClose();
                dispatch(logOut());
              }}
            >
              Cerrar sesión
            </MenuItem>
          </Menu>
        </div>
      </div>
    </div>
  );
};

export default HeaderSection;
